import React from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';

@observer
export class SearchForm extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.store = this.props.store;
  }

  handleInput = (event) => {
    this.store.handleInput(event.target.value)
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.store.searchApps();
  }

  handleClearClick = () => {
    this.store.clearSearchQuery();
  }

  render() {
    const clearButtonVisible = this.store.searchQuery.length > 0;
    return (<form className="search-input form-group" onSubmit={this.handleSubmit}>
      <label htmlFor="search-box" className="form-group-title">
        <span className="sr-only">Search catalog by</span>App Name
      </label>
      <div className="input-group">
        <input
          id="search-box"
          className="form-control"
          type="search" onChange={this.handleInput} value={this.store.searchQuery} />
        {clearButtonVisible && <span className="input-group-append">
          <button className="clear-btn" type="button" onClick={this.handleClearClick}>
            <span className="sr-only">Clear</span>
            <span aria-hidden="true" className="icon-close"/>
          </button>
        </span>}
        <span className="input-group-append">
          <button className="submit-btn" type="submit">
            <span className="sr-only">Search</span>
            <span aria-hidden="true" className="icon-search"/>
          </button>
        </span>
      </div>
    </form>);
  }
}
